export enum SalesStatus {
    Available = 'AVAILABLE',
    NotYetOnSale = 'NOT_YET_ON_SALE',
    SoldOut = 'SOLD_OUT',
    Unavailable = 'UNAVAILABLE',
}
